module.exports = "/images/pin2.svg?330c64a6d05faef146904b0160f0a3cc";